import flamelink from '@flamelink/sdk-app';



export default flamelink;
